import React from "react";

const HamburgerIocn = ({ fill }) => {
  return (
    // #0051bc
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.846"
      height="15.763"
      viewBox="0 0 20.846 15.763"
    >
      <g
        id="Group_1026"
        data-name="Group 1026"
        transform="translate(-176 -21.5)"
      >
        <line
          id="Line_324"
          data-name="Line 324"
          x2="20.846"
          transform="translate(176 22.5)"
          fill="none"
          stroke={fill}
          strokeWidth="2"
        />
        <line
          id="Line_325"
          data-name="Line 325"
          x2="20.846"
          transform="translate(176 29.381)"
          fill="none"
          stroke={fill}
          strokeWidth="2"
        />
        <line
          id="Line_326"
          data-name="Line 326"
          x2="20.846"
          transform="translate(176 36.263)"
          fill="none"
          stroke={fill}
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};


export default HamburgerIocn;